import {IActivityTracker as IActivityTrackerParent} from '@telstra-connect/utils/activity-tracking'

declare let s: {
  track: (name: string, parameter: object) => void
}

const routePrefix = '/app/'

interface IActivityTracker extends IActivityTrackerParent {}

const Activity = {
  trackPage(url: string) {
    // eslint-disable-next-line dot-notation,@typescript-eslint/dot-notation
    if (!url || !window['s']) {
      return
    }

    const pageName = url.startsWith(routePrefix) ? url.substring(routePrefix.length) : url

    s.track('page', {pageName})
  },

  trackLink: (applicationPrefix: string) => (parentComponentName: string, name: string) => {
    // eslint-disable-next-line dot-notation,@typescript-eslint/dot-notation
    if (!window['s']) {
      return
    }

    if (!applicationPrefix) {
      throw new Error('applicationPrefix is mandatory')
    }

    if (!parentComponentName) {
      throw new Error('parentComponentName is mandatory')
    }

    if (!name) {
      throw new Error('link name is mandatory')
    }

    s.track('link', {linkName: `${applicationPrefix}:${parentComponentName}:${name}`})
  },

  createTracker(applicationPrefix: string): IActivityTracker {
    return {
      trackTile: (name: string) => {
        Activity.trackLink(applicationPrefix)('tile', name)
      },

      trackMenu: (name: string) => {
        Activity.trackLink(applicationPrefix)('menu', name)
      },

      trackLink: Activity.trackLink(applicationPrefix),
    }
  },
}

export {IActivityTracker, Activity}
